<template>
  <div class="unit-actions"
    :class="expanded ? 'actions-visible' : ''">
    <div class="detail-btn" @click="emit('handleAction', 'details')">
      <div>
        <img src="../../assets/left_arrow.svg" />
        <span class="tiny-reg black-default">Details</span>
      </div>
    </div>
    <div
      class="detail-btn"
      @click="emit('handleAction', 'more')"
      style="
        border-top: 1px solid var(--black-light);
        border-bottom: 1px solid var(--black-light);
      "
    >
      <div>
        <img src="../../assets/link.svg" />
        <span class="tiny-reg black-default">More</span>
      </div>
    </div>
    <div
      class="detail-btn"
      @click="emit('handleAction', 'interested'), emit('handleAction', 'details')"
      :style="{ backgroundColor: interested ? '#686767' : '' }"
    >
      <div>
        <img src="../../assets/check_mark_no_bg.svg" />
        <span class="tiny-reg black-default">Interested</span>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  unit: { type: Object },
  interested: {type: Boolean, required: false, default: false},
  expanded: { type: Boolean, required: false, default: false },
});

const emit = defineEmits(["handleAction"]);
</script>

<style>
.unit-actions {
  flex-direction: column;
  position: absolute;
  box-shadow: 0px 0px 30px 0 rgba(0, 0, 0, 0.5);
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 3;
  display: none;
  opacity: 0;
  transition: opacity 0.25s ease-out;
}

.actions-visible {
  opacity: 1;
  display: flex;
}

.detail-btn {
  flex-grow: 1;
  width: 66px;
  text-align: center;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  background-color: white;
}

.detail-btn:active {
  background-color: var(--black-medium);
}

.detail-btn > div {
  width: 48px;
  height: 48px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: end;
}

.detail-btn > div > img {
  margin-bottom: 7px;
}
</style>